export default "__VITE_ASSET__BgNvNPXe__"